import { useState, useContext } from 'react'
import { DataContext, DataDispatchContext } from '../../../contexts/data/dataContext'
import { 
  homeIconDefault,
  homeIconSelected,
  solarIconDefault,
  solarIconSelected,
  batteryIconDefault,
  batteryIconSelected,
  gridIconDefault,
  gridIconSelected,
  // sunIconPath,
  // downloadIconPath2
} from '../../common/iconPaths'
import LeftNavigation from '../../common/leftNavigation';


export default function ReportLeftNavigation({ clickAnalytics }: any) {
    const dispatch: any = useContext(DataDispatchContext)
    const data: any = useContext(DataContext)
    const [selected, setSelected] = useState(data?.reportSelected);
 
    const handleMenuClick = (event: any) => {
      const id = event.currentTarget.id
      setSelected(id)
      dispatch({
          type: 'setReportSelected',
          selected: id
        })
        clickAnalytics(id)
      }

    const navItemList = [
        {
            id: 'home',
            name: "Home",
            iconPath: homeIconDefault,
            selected: homeIconSelected,
            action: handleMenuClick
        },
        {
            id: 'solar',
            name: "Solar",
            iconPath: solarIconDefault,
            selected: solarIconSelected,
            action: handleMenuClick
        },
        {
            id: 'battery',
            name: "Battery",
            iconPath: batteryIconDefault,
            selected: batteryIconSelected,
            action: handleMenuClick
        },
        {
            id: 'grid',
            name: "Grid",
            iconPath: gridIconDefault,
            selected: gridIconSelected,
            action: handleMenuClick
        }
      ]

    return (
      <LeftNavigation 
        itemSelected={selected}
        defaultSelected={"home"} 
        title={"Performance"} 
        navItemList={navItemList}
        menuDisplay={{ 
          xs: 'none', 
          sm: data.rightPanel?'none':'flex', 
          md: 'flex', 
          lg: 'flex'
        }}
      />
    )
}